import { FunctionComponent } from 'react'
import { formatTableDate } from '../helpers/formatTableDate'

/**
 * A component that displays a date and time on separate lines.
 * @param date - A Date object.
 * @returns A string of the date and time in this format:
 *
 * Aug 5, 2025
 *
 * 13:51
 */
export const DateAndTime: FunctionComponent<DateAndTimeProps> = ({ date }) => {
  /** A string of the date in this format: Aug 5, 2025 */
  const dateString = formatTableDate(date)

  /** A string of the time in this format: 13:51 */
  const timeString = date
    .toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: false,
    })
    .replace(/^0/, '')

  return (
    <>
      {dateString}
      <br />
      {timeString}
    </>
  )
}

interface DateAndTimeProps {
  date: Date
}
